import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NoticeTooltipOnHover from '../../../_utils/notice-tooltip';
import PhotoLowResolutionIcon from './photo-low-resolution-icon';
import { SMALL_CROP_MESSAGE } from './constants';

// Displays a warning when a photo has been cropped too small for the print size, with a tooltip.
const CroppedTooSmallBadge = ({ tooltipPosition, tooltipCSSClasses, id }) => (
  <NoticeTooltipOnHover
    tooltipCSSClasses={classNames(
      'dpi-tooltip',
      'dpi-tooltip-below-recommended',
      tooltipCSSClasses,
    )}
    tooltipPosition={tooltipPosition}
    content={SMALL_CROP_MESSAGE}
    show={false}>
    <div className="dpi-notice__container" tabIndex="0">
      <PhotoLowResolutionIcon
        id={id}
        className="dpi-notice-below-recommended"
        aria-label={SMALL_CROP_MESSAGE}
      />
    </div>
  </NoticeTooltipOnHover>
);

CroppedTooSmallBadge.propTypes = {
  tooltipPosition: PropTypes.string,
  tooltipCSSClasses: PropTypes.string,
  id: PropTypes.string,
};

CroppedTooSmallBadge.defaultProps = {
  tooltipPosition: undefined,
  tooltipCSSClasses: undefined,
  id: undefined,
};

export default CroppedTooSmallBadge;
